<template>
  <div>
    <sui-button color="blue" icon="arrow left" label-position="left" @click="goBack($event, '/')">{{$t('btnBack')}}</sui-button>
    <sui-segment raised>
      <sui-container text-align="left">
        <ContentConditions />
      </sui-container>
    </sui-segment>
  </div>
</template>


<script>
  import ContentConditions from '@/views/static/Conditions.vue'

  export default {
    name: 'Conditions',
    components: {
      ContentConditions
    },
    metaInfo() {
      return {
        title: this.$t('labelConditions'),
        meta: [
          /*{ vmid: 'description', name: 'description', content: this.data.content }*/
        ]
      }
    },
    data() {
      return {
        fromRoute: null
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.fromRoute = from;
      })
    },
    methods: {
      goBack(event, fallback) {
        if (event) {
          event.preventDefault()
        }
        if (this.fromRoute == null || !this.fromRoute.name) {
          this.$router.push(fallback);
        } else {
          this.$router.back();
        }
      }
    },
  };
</script>
